export type WheelColor = "red" | "green" | "white" | "black";

export interface WheelSegment {
  color: WheelColor;
  path: string;
  // Штырёк на ободе, на границе секторов.
  peg: { x: number; y: number };
}

const COLORS: WheelColor[] = ["black", "white", "green", "red"];

const round = (value: number): number => Math.round(value * 100) / 100;

// Секторы по часовой стрелке от верхней точки круга.
export const getWheelSegments = (
  count: number,
  center: number,
  radius: number,
): WheelSegment[] => {
  const pointAt = (index: number) => {
    const angle = (index / count) * 2 * Math.PI - Math.PI / 2;
    return {
      x: round(center + radius * Math.cos(angle)),
      y: round(center + radius * Math.sin(angle)),
    };
  };

  return Array.from({ length: count }, (_, index) => {
    const from = pointAt(index);
    const to = pointAt(index + 1);
    return {
      color: COLORS[index % COLORS.length],
      path: `M${center} ${center}L${from.x} ${from.y}A${radius} ${radius} 0 0 1 ${to.x} ${to.y}Z`,
      peg: from,
    };
  });
};
